import e, { useState as b, useReducer as P, createContext as O, forwardRef as R, useRef as A, useMemo as H, useEffect as U, lazy as W, Suspense as X, Component as z } from "react";
import { c as p, t as h } from "./app-a75c1d35.mjs";
import { I as T, W as B } from "./Icon-3122c134.mjs";
import { I as i, a as d } from "./Image-d6406817.mjs";
import { L as f } from "./Link-479ac100.mjs";
import { B as v } from "./Button-c598cb52.mjs";
import { u as F } from "./index-615eb227.mjs";
import { B as E } from "./Block-9b78bd10.mjs";
const $ = "MapBox__container", G = "MapBox__card", K = "MapBox__large-desktop", V = "MapBox__desktop", j = "desktop", q = "MapBox__image", J = "MapBox__tablet", Q = "MapBox__dropDown", Y = "MapBox__small__tablet", Z = "MapBox__mobile", ee = "MapBox__content", te = "MapBox__contentOnMap", ae = "MapBox__contentOnMap__hidden", oe = "picture", ne = "MapBox__svg__close", se = "MapBox__leadText", re = "MapBox__buttons", r = {
  mapBoxContainer: $,
  mapBoxCard: G,
  mapBoxLargeDesktop: K,
  mapBoxDesktop: V,
  desktop: j,
  mapBoxImage: q,
  mapBoxTablet: J,
  mapBoxDropDown: Q,
  mapBoxSmallTablet: Y,
  mapBoxMobile: Z,
  mapBoxContent: ee,
  mapBoxContentOnMap: te,
  mapBoxContentOnMapHidden: ae,
  picture: oe,
  mapBoxSvgClose: ne,
  mapBoxLeadText: se,
  mapBoxButtons: re
}, pe = "MapDropdown", ce = "MapDropdown__list", le = "MapDropdown__list__item", me = "MapDropdown__selected", ie = "MapDropdown__chevron", g = {
  mapDropdown: pe,
  mapDropdownList: ce,
  mapDropdownListItem: le,
  mapDropdownSelected: me,
  mapDropdownChevron: ie
};
var u = /* @__PURE__ */ ((t) => (t.MapOnImage = "mapOnImage", t.MapOnMap = "mapOnMap", t))(u || {});
function de({
  cities: t,
  variant: o,
  onClickShowMarker: s,
  selected: l,
  setSliderIndex: x
}) {
  const [a, n] = b(!1), [m, M] = b("Select a city "), [c, k] = b(!1), I = () => {
    n(!a), k(!c), M("Select a city");
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "mapbox-dropdown",
      className: p(g.mapDropdown),
      onClick: () => I()
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        "data-testid": "mapbox-dropdown-selected",
        className: p(
          g.mapDropdownSelected,
          c ? h.textsBodyText : h.textsBodyTextBold
        ),
        id: "selected"
      },
      /* @__PURE__ */ e.createElement("span", null, c ? m : l?.name),
      /* @__PURE__ */ e.createElement(
        T,
        {
          icon: c ? B.CHEVRON_UP : B.CHEVRON_DOWN,
          size: 18,
          color: "#002EA2",
          className: p(g.mapDropdownChevron)
        }
      )
    ),
    a ? /* @__PURE__ */ e.createElement(
      "ul",
      {
        className: p(g.mapDropdownList),
        "data-testid": "mapbox-dropdown-list"
      },
      t?.map((N, _) => {
        const w = N.city.name;
        return /* @__PURE__ */ e.createElement(
          "li",
          {
            "data-testid": "mapbox-dropdown-item",
            className: p(
              g.mapDropdownListItem,
              h.textsBodyText
            ),
            onClick: () => {
              o === u.MapOnMap ? (n(!a), s && setTimeout(() => {
                s(t[_].position, _);
              }, 200)) : (x?.(_), n(!a), M(w), k(!c));
            },
            key: w
          },
          w
        );
      })
    ) : null
  );
}
const D = {
  toggle: { type: "toggle" }
}, S = O(void 0), L = O(void 0);
function xe(t, o) {
  switch (o.type) {
    case D.toggle.type:
      return { ...t, isRealMapShown: !t.isRealMapShown };
    default:
      throw new Error(`Unhandled action type: ${o}`);
  }
}
function ge({ children: t }) {
  const [o, s] = P(xe, {
    isRealMapShown: !1
  });
  return /* @__PURE__ */ e.createElement(L.Provider, { value: s }, /* @__PURE__ */ e.createElement(S.Provider, { value: o }, t));
}
function Be() {
  const t = e.useContext(S);
  if (t === void 0)
    throw new Error("useMap must be used within a MapProvider");
  return t;
}
function y() {
  const t = e.useContext(L);
  if (t === void 0)
    throw new Error("useMap must be used within a MapProvider");
  return t;
}
const ue = R(
  function(o, s) {
    const l = y(), {
      cities: x,
      selected: a,
      variant: n,
      togglePopUp: m,
      onClickShowMarker: M,
      setSliderIndex: c
    } = o;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: p(
          n === u.MapOnImage ? r.mapBoxContent : r.mapBoxContentOnMap
        ),
        "data-testid": "mapbox-content",
        ref: s
      },
      /* @__PURE__ */ e.createElement(
        "div",
        {
          "data-testid": "mapbox-close",
          onClick: () => {
            n === u.MapOnImage ? l(D.toggle) : m?.();
          },
          className: p(r.mapBoxSvgClose)
        },
        /* @__PURE__ */ e.createElement(T, { size: 14, icon: B.CLOSE, color: "#002EA2" })
      ),
      a && /* @__PURE__ */ e.createElement(
        i,
        {
          credits: a.imageData.credits ?? "",
          className: p(r.mapBoxImage),
          src: a.imageData.imageSrc,
          width: a.imageData.width,
          height: a.imageData.height,
          altText: a.alt,
          imageLoader: a.imageData.imageLoader,
          styling: d.PROMOTION,
          "data-testid": "mapbox-pop-up-image"
        }
      ),
      /* @__PURE__ */ e.createElement(
        de,
        {
          variant: n,
          cities: x,
          selected: a,
          onClickShowMarker: M,
          setSliderIndex: c
        }
      ),
      /* @__PURE__ */ e.createElement("div", { className: p(r.mapBoxLeadText, h.textsBodyText) }, a?.cityLeadText),
      /* @__PURE__ */ e.createElement("div", { className: p(r.mapBoxButtons) }, a?.externalLink && /* @__PURE__ */ e.createElement(
        f,
        {
          href: a?.externalLink,
          locale: a?.externalLinkLocale,
          target: "_blank"
        },
        /* @__PURE__ */ e.createElement(
          v.Primary,
          {
            asDiv: !0,
            "data-testid": "mapbox-explore-services-button",
            text: a?.externalLinkText ?? "",
            icon: B.ARROW_UP_RIGHT
          }
        )
      ), a?.secondExternalLink && /* @__PURE__ */ e.createElement(
        f,
        {
          href: a?.secondExternalLink,
          locale: a?.secondExternalLinkLocale,
          target: "_blank"
        },
        /* @__PURE__ */ e.createElement(
          v.Secondary,
          {
            asDiv: !0,
            "data-testid": "mapbox-more-information-button",
            text: a?.secondExternalLinkText ?? "",
            icon: B.ARROW_UP_RIGHT
          }
        )
      ))
    );
  }
);
function Me({ cities: t }) {
  const o = y(), s = A(null);
  F(s, (n) => {
    n && o(D.toggle);
  });
  const l = H(
    () => t.map((n) => ({ position: [0, 0], city: n })),
    [t]
  ), [x, a] = b(0);
  return U(() => {
    const n = setInterval(() => {
      a((m) => m === t.length - 1 ? 0 : m + 1);
    }, 12e3);
    return () => clearInterval(n);
  }, [t.length]), /* @__PURE__ */ e.createElement(
    ue,
    {
      variant: u.MapOnImage,
      selected: l[x].city,
      setSliderIndex: a,
      cities: l,
      ref: s
    }
  );
}
const Ee = "/static/images/mapbox/Tablet.webp", be = ({ className: t }) => /* @__PURE__ */ e.createElement("div", { className: t }, /* @__PURE__ */ e.createElement(
  i,
  {
    src: Ee,
    width: 2046,
    height: 2732,
    altText: "Background image",
    styling: d.MAPBOX
  }
)), he = "/static/images/mapbox/Smalltablet.webp", _e = ({ className: t }) => /* @__PURE__ */ e.createElement("div", { className: t }, /* @__PURE__ */ e.createElement(
  i,
  {
    width: 1798,
    height: 2401,
    src: he,
    altText: "Background image",
    styling: d.MAPBOX
  }
)), we = "/static/images/mapbox/Desktop.webp", De = ({ className: t }) => /* @__PURE__ */ e.createElement("div", { className: t }, /* @__PURE__ */ e.createElement(
  i,
  {
    src: we,
    width: 2878,
    height: 2048,
    altText: "Background image",
    styling: d.MAPBOX
  }
)), ke = "/static/images/mapbox/Mobile.webp", fe = ({ className: t }) => /* @__PURE__ */ e.createElement("div", { className: t }, /* @__PURE__ */ e.createElement(
  i,
  {
    src: ke,
    width: 1198,
    height: 1600,
    altText: "Background image",
    styling: d.MAPBOX
  }
)), ve = "/static/images/mapbox/Largedesktop.webp", Ce = ({ className: t }) => /* @__PURE__ */ e.createElement("div", { className: t }, /* @__PURE__ */ e.createElement(
  i,
  {
    src: ve,
    width: 3840,
    height: 2731,
    altText: "Background image",
    styling: d.MAPBOX
  }
));
function Oe() {
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    Ce,
    {
      className: r.mapBoxLargeDesktop,
      "data-testid": "mapbox-large-desktop"
    }
  ), /* @__PURE__ */ e.createElement(
    De,
    {
      className: r.mapBoxDesktop,
      "data-testid": "mapbox-desktop"
    }
  ), /* @__PURE__ */ e.createElement(be, { className: r.mapBoxTablet, "data-testid": "mapbox-tablet" }), /* @__PURE__ */ e.createElement(
    _e,
    {
      className: r.mapBoxSmallTablet,
      "data-testid": "mapbox-small-tablet"
    }
  ), /* @__PURE__ */ e.createElement(fe, { className: r.mapBoxMobile, "data-testid": "mapbox-mobile" }));
}
const Te = W(() => import("./MapBox-95439868.mjs"));
function We(t) {
  return /* @__PURE__ */ e.createElement(ge, null, /* @__PURE__ */ e.createElement(Se, { ...t }));
}
function Se(t) {
  const { isRealMapShown: o } = Be(), s = !!(o && t.MAPBOX_TOKEN);
  return /* @__PURE__ */ e.createElement(
    E,
    {
      topPadding: E.Padding.NONE,
      bottomPadding: E.Padding.NONE,
      "data-testid": "mapbox-block"
    },
    /* @__PURE__ */ e.createElement(
      E.Content,
      {
        className: p(r.mapBoxCard),
        "data-testid": "mapbox-content",
        limitedWidth: !s
      },
      s ? (
        // Real Mapbox
        /* @__PURE__ */ e.createElement(Le, { fallback: /* @__PURE__ */ e.createElement(C, { cities: t.cities }) }, /* @__PURE__ */ e.createElement(X, null, /* @__PURE__ */ e.createElement(Te, { ...t })))
      ) : (
        // Static slider of cities
        /* @__PURE__ */ e.createElement(C, { cities: t.cities })
      )
    )
  );
}
function C({ cities: t }) {
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(Oe, null), /* @__PURE__ */ e.createElement(Me, { cities: t }));
}
class Le extends z {
  constructor(o) {
    super(o), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
export {
  ue as M,
  u as a,
  We as b,
  r as s
};
//# sourceMappingURL=index-66bc4f34.mjs.map
